import React from 'react';
import { Card } from '../../../components/ui/card';
import { ResponsiveContainer, AreaChart, Area } from 'recharts';
import { TrendingUp, TrendingDown } from 'lucide-react';

export const DeltaChip = ({ delta, suffix }) => {
  if (!delta) return null;
  const up = delta.pct >= 0;
  return (
    <span
      className={`text-xs font-semibold px-2 py-0.5 rounded-full flex items-center gap-1 w-fit ${
        up
          ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400'
          : 'bg-rose-50 text-rose-700 dark:bg-rose-500/10 dark:text-rose-400'
      }`}
      data-testid="delta-chip"
    >
      {up ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
      {Math.abs(delta.pct).toFixed(1)}%{suffix ? ` ${suffix}` : ''}
    </span>
  );
};

export const StatCard = ({ label, value, icon: Icon, accent = '#4f46e5', delta, deltaLabel, spark, testId }) => (
  <Card
    className="p-5 lg:p-6 border-slate-200 dark:border-slate-800 hover:-translate-y-1 hover:shadow-lg transition-[transform,box-shadow] duration-300 ease-out"
    data-testid={testId}
  >
    <div className="flex items-start justify-between gap-3">
      <p className="text-xs font-medium uppercase tracking-wider text-slate-500 dark:text-slate-400">{label}</p>
      {Icon && (
        <div className="p-1.5 rounded-lg shrink-0" style={{ backgroundColor: `${accent}1a` }}>
          <Icon className="h-4 w-4" style={{ color: accent }} />
        </div>
      )}
    </div>
    <p className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 dark:text-white mt-2 tabular-nums break-words leading-tight">
      {value}
    </p>
    <div className="flex items-center gap-2 mt-2 min-h-[22px]">
      {delta && <DeltaChip delta={delta} />}
      {deltaLabel && <span className="text-xs text-slate-400">{deltaLabel}</span>}
    </div>
    {spark && spark.length > 1 && (
      <div className="h-9 -mx-1 mt-1">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={spark} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
            <defs>
              <linearGradient id={`spark-${testId}`} x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={accent} stopOpacity={0.3} />
                <stop offset="100%" stopColor={accent} stopOpacity={0} />
              </linearGradient>
            </defs>
            <Area type="monotone" dataKey="v" stroke={accent} strokeWidth={1.6} fill={`url(#spark-${testId})`} />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    )}
  </Card>
);
